/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PaymentMethodState = zod
	.object({
		has_payment_method: zod.boolean().describe('Whether a default payment method is configured')
	})
	.describe('Payment method state');

export type PaymentMethodState = zod.input<typeof PaymentMethodState>;
export type PaymentMethodStateOutput = zod.output<typeof PaymentMethodState>;
